import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const SubmitButtonController = ({ action, state }) => {
  const productState = useSelector((reduxState) => reduxState.get("products"));
  const validation = productState?.get ? productState.get("validation") : productState?.validation;
  const current = productState?.get ? productState.get("current") : productState?.current;

  const isGtinValidated =
    (state?.__gtinValidated || current?.__gtinValidated || validation?.gtinValidated) &&
    !validation?.gtinValidationError;

  useEffect(() => {
    if (action !== "create") {
      return;
    }

    setTimeout(() => {
      const submitButton = document.querySelector('form button[type="submit"]');

      if (submitButton) {
        if (isGtinValidated !== true) {
          submitButton.disabled = true;
          submitButton.style.opacity = "0.5";
          submitButton.style.cursor = "not-allowed";
        } else {
          submitButton.disabled = false;
          submitButton.style.opacity = "1";
          submitButton.style.cursor = "pointer";
        }
      }
    }, 100);
  }, [action, isGtinValidated, state?.__gtinValidated, validation]);

  return null;
};

export default SubmitButtonController;
